@let currModelRoom = roomListAccessService.getCurrentModelRoom$() | async;
@if (currModelRoom) {
  <div class="message-stream">
    @for (message of chatMessageService.messages$ | async; track message.id) {
      @if (message.type === DisplayItemType.MESSAGE || message.type === DisplayItemType.FILEMESSAGE) {
        @if (this.readMarkerId() === message.id) {
          <div [id]="'lastRead_' + message.id" [attr.data-testid]="testIds.lastRead" class="animated-marker">
            <span>Zuletzt gelesen</span>
          </div>
        }
        <div class="message-container" #messageDiv>
          @if (
            toolbarMessageId === message.id &&
            roomHelperService.getRoomMembership(currModelRoom.roomId) !== KnownMembership.Leave
          ) {
            <app-message-toolbar
              class="app-message-toolbar"
              [room]="currModelRoom"
              (toolbarMessageId)="setToolbarMessageId($event)"
              (toolbarClosed)="toolbarMessageId = ''"
              [message]="asDisplayMessage(message)">
            </app-message-toolbar>
          }
          <app-sb-message
            [room]="currModelRoom"
            [ngClass]="matrix.getUserId() === asDisplayMessage(message)?.senderId ? 'sendMsg' : 'receivedMsg'"
            [message]="asDisplayMessage(message)!"
            [messageFile]="asDisplayMessageFile(message)"
            (toolbarMessageId)="setToolbarMessageId($event)"
            [id]="message.id">
          </app-sb-message>
        </div>
      } @else if (message.type === DisplayItemType.INFO) {
        <div class="message-container">
          <app-sb-informations-anzeige
            [text]="asDisplayInfo(message)?.personalizedInfotext"
            [id]="message.id"></app-sb-informations-anzeige>
        </div>
      }
    }
  </div>
}
